import { useRouter } from 'next/router';

import * as S from './style';

interface Props {
  companyName?: string;
  PK_NM_HASH?: string;
}

export default function SalaryReportSection({ companyName, PK_NM_HASH }: Props) {
  const router = useRouter();
  const handleClick = () => {
    router.push('/salaryreport/step');
  };

  return (
    <S.Wrapper>
      <S.Title typography='midium150_B1'>내 연봉 순위가 궁금하다면?</S.Title>
      <S.Button
        size='lg'
        onClick={handleClick}
        leading={
          <img
            srcSet='https://image.wanted.co.kr/kreditjob/www/ico-trophy.png, https://image.wanted.co.kr/kreditjob/www/ico-trophy@2x.png 2x'
            src='https://image.wanted.co.kr/kreditjob/www/ico-trophy.png'
            alt=''
          />
        }
        data-attribute-id='company__salaryRank__click'
        data-company-name={companyName}
        data-company-hash={PK_NM_HASH}>
        연봉 제보하기
      </S.Button>
    </S.Wrapper>
  );
}
